import { general } from './general';

export const ssn = (data = {}) => general('ssn', (data || {}));
